import styled, { keyframes } from 'styled-components';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  background: #0f0f0f;

  display: flex;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Sidebar = styled.div`
  width: 10rem;
  height: 100%;

  border-right: 1px solid #cfcfcf;

  > ul {
    > li {
      display: flex;
      align-items: center;

      height: 5.2rem;
      padding-left: 1rem;

      cursor: pointer;
      transition: ${({ theme }) => theme.transition.default};

      > p {
        font-size: 1.6rem;
        line-height: 3.5rem;
        color: #ffffff;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      :hover {
        background: #242424;
      }

      &.active {
        background: #242424;
        border-right: 4px solid #ffd503;

        > p {
          font-weight: bold;
          color: #ffdf22;
        }
      }

      @media (min-width: 768px) {
        padding-left: 3.2rem;

        > p {
          font-size: 1.9rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    width: 27rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: auto;

  animation: ${appearOpacity} 0.5s ease-in;
`;

export const StudentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 2rem;

  background: #242424;
  width: 100%;
  height: 10.6rem;

  border-bottom: 1px solid #cfcfcf;

  > h1 {
    font-weight: bold;
    font-size: 2.5rem;
    letter-spacing: 1.25px;
    line-height: 3rem;
    text-transform: uppercase;
    color: #ffdf22;
    > button {
      font-weight: bold;
      font-size: 2.5rem;
      letter-spacing: 1.25px;
      line-height: 3rem;
      text-transform: uppercase;
      color: #ffdf22;
      background: transparent;
      display: flex;
      justify-content: center;
      margin-left: 8px;
    }
  }

  @media (min-width: 768px) {
    padding: 0 5.6rem;
  }
`;

export const StudentContent = styled.div`
  width: 100%;

  h1 {
    color: #fff;
  }
`;

export const ButtonSave = styled.button`
  width: 100%;
  max-width: 31.7rem;

  height: 4.4rem;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%);
  border-radius: 5rem;

  font-weight: bold;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #0f0f0f;

  transition: ${({ theme }) => theme.transition.default};

  :hover {
    opacity: 0.85;
  }
`;

export const InputContainer = styled.div`
  background: #fff;
  width: 80%;
  height: 5rem;
  @media (min-width: 475px) {
    display: flex;
  }
  @media (min-width: 768px) {
    max-width: 42rem;
  }
  display: flex;
  align-items: center;
  height: 100%;
  input {
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 10px;
    font-size: 1.7rem;
    letter-spacing: 0.85px;
    line-height: 2.1rem;
    color: #000;

    &::placeholder {
      color: #000000;
    }
  }
`;

export const InputsContainer = styled.div`
  max-width: 800px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 70px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const SettingContainer = styled.div`
  padding: 70px;
`;

export const LogoImage = styled.label`
  width: 100%;
  max-width: 280px;
  height: auto;
  max-height: 280px;
  background-color: #aaa;
  display: inline-block;
  overflow: hidden;
  background-image: url(/avatar_placeholder.png);
  background-position: center;
  background-repeat: no-repeat;
  input {
    position: absolute;
    opacity: 0;
  }
`;

export const ImageLogoRender = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const InputSettings = styled.input`
  width: 100%;
  outline: none;
  margin-bottom: 2rem;
  padding: 4px 8px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    width: 22rem;
  }
  border-radius: 20px;
`;

export const LabelStyle = styled.label`
  display: block;
  @media (max-width: 800px) {
    width: 22rem;
    grid-template-columns: 1fr;
  }
  color: #fff;
`;

export const PackageContainer = styled.div`
  padding: 70px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: column;
  grid-template-rows: 1fr 1fr 1fr;
`;
export const PackValue = styled.div`
  display: grid;
`;
export const PackInputSettings = styled.input`
  width: 50%;
  outline: none;
  margin-bottom: 2rem;
  padding: 4px 8px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    width: 22rem;
  }
  border-radius: 20px;
`;

export const PackLabelStyle = styled.label`
  display: block;
  @media (max-width: 800px) {
    width: 22rem;
    grid-template-columns: 1fr;
  }
  color: #fff;
`;
